import React, { Component } from 'react';
import { CheckBox } from '../common/forms';
import { LabelWithArrow, Load } from '../common/basic';
import ReactDom from 'react-dom';
import axios from 'axios';
import { Radio } from 'react-bootstrap';
import dateHelper from '../../helpers/date';
import ReactModal from 'react-modal';

import ScheduleComponent from './ScheduleComponent';


module.exports = class ScheduleBoxOption extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            RepeatDates: '',
            RepeatDay: '',
            RepeatType: ''
        }

        this.ScheduleChange = this.ScheduleChange.bind(this);
    }

    changeValues(Repeat) {
        this.setState({
            RepeatDates: Repeat.RepeatDates,
            RepeatDay: Repeat.RepeatDay,
            RepeatType: Repeat.RepeatType
        });

        this.Schedule.changeValues(Repeat.RepeatType, Repeat.RepeatDay, Repeat.RepeatDates);
    }

    changeType(RepeatType, e) {
        this.setState({
            RepeatType: RepeatType
        });
    }

    openPopup(e) {
        e.preventDefault();
        this.Schedule.handleOpenModal();
    }

    ScheduleChange(RepeatType, RepeatDay, RepeatDates) {
        if (RepeatType == "FREE")
            this.setState({
                RepeatType: RepeatType,
                RepeatDates: RepeatDates
            });
        else if (RepeatType == "DAILY") {
            this.setState({
                RepeatType: RepeatType
            });
        }
        else {
            this.setState({
                RepeatType: RepeatType,
                RepeatDay: RepeatDay
            });
        }
    }

    MakeSplittedDates(RepeatDates) {
        var dates = "";
        if (RepeatDates) {
            for (var i = 0; i < RepeatDates.length; i++) {
                if (dates != "")
                    dates += ',';
                var repeatDate;
                if (dateHelper.validateDateFromClient(RepeatDates[i])) {
                    repeatDate = dateHelper.fromStrToDBStr(RepeatDates[i]);
                }
                else {
                    repeatDate = dateHelper.fromDateToDBStr(RepeatDates[i]);
                }
                dates += repeatDate;

            }
        }
        return dates;
    }

    render() {
        var className = 'treatmentBoxOption ' + this.props.className;

        var repeatDays = "";
        if (this.state.RepeatType == "WEEKLY") {
            repeatDays = "Every " + dateHelper.fromNumberToWeekDay(this.state.RepeatDay[0]);
        }
        else if (this.state.RepeatType == "BIWEEKLY") {
            repeatDays = "Every " + dateHelper.fromNumberToWeekDay(this.state.RepeatDay[0]) + ", " + dateHelper.fromNumberToWeekDay(this.state.RepeatDay[1]);
        }
        else if (this.state.RepeatType == "MONTHLY") {
            repeatDays = "Every " + this.state.RepeatDay[0] + "th";
        }
        else if (this.state.RepeatType == "FREE") {
            repeatDays = "Free";
        }

        var ID = this.props.ID;

        var repeatTypeID = "RepeatType_" + ID;
        var repeatDayID = "RepeatDay_" + ID;
        var repeatDatesID = "RepeatDates_" + ID;

        var datesVal = this.MakeSplittedDates(this.state.RepeatDates);

        return (
            <div className={className}>

                <div className='row'>
                    <div className='col-xs-6 scheduleIcon'>
                        <img className='center-block' src='/gallery/doctorAdvice/schedule_purple_icon.png' />
                        <div className='editShedule'>
                            <button onClick={this.openPopup.bind(this)}>Add Schedule</button>
                            <ScheduleComponent ID={this.props.ID}
                                ref={(Schedule) => { this.Schedule = Schedule; }} onChange={this.ScheduleChange} />
                        </div>
                    </div>
                    <div className='col-xs-6 chosenSchedule'>
                        <div className='font-weight-bold'>{this.state.RepeatType}</div>
                        {repeatDays}
                    </div>
                    <input type='hidden' id={repeatTypeID} name={repeatTypeID} value={this.state.RepeatType} />
                    <input type='hidden' id={repeatDayID} name={repeatDayID} value={this.state.RepeatDay} />
                    <input type='hidden' id={repeatDatesID} name={repeatDatesID} value={datesVal} />
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./modules/doctorAdvice/ScheduleBoxOption.jsx